// extracted by mini-css-extract-plugin
export default {"header":"Yp","fullPage":"Zp","closed":"aq","minimize":"bq","redcircle":"cq","container":"eq","text":"fq","centered":"gq","escapex":"hq"};
    if(module.hot) {
      // 1711394575897
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  